import { FileImageOutlined } from '@ant-design/icons';
import { Button, message, Modal, Space, Upload } from 'antd';
import firebase from 'firebase';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

type UpdateImageButtonProps = {
  investmentId?: string;
  style?: React.CSSProperties;
};

export const UpdateImageButton = ({ investmentId, style }: UpdateImageButtonProps) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [fileList, setFileList] = useState([]);

  const buttonClickHandler = () => {
    setVisible(true);
  };

  const modalCancelHandler = () => {
    setFileList([]);
    setVisible(false);
  };

  const renderModalButtons = () => [
    <Button key="cancel" onClick={modalCancelHandler}>
      {t('cancel')}
    </Button>,
  ];

  const customRequest = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const key = file.name;
    const fileRef = firebase.storage().ref(`Investments/Images/${investmentId}/${key}`);
    try {
      const task = fileRef.put(file);
      task.on(
        'state_changed',
        (snap) => {
          const progress = (snap.bytesTransferred / snap.totalBytes) * 100;
          message.loading({ key, content: t('uploadDocumentLoading', { progress }) });
          onProgress({ percent: progress });
        },
        (err) => {
          message.error({ key, content: t('uploadDocumentError', { error: err }) });
          onError(err);
        },
        () => {
          message.success({ key, content: t('uploadDocumentSuccess') });
          setVisible(false);
          onSuccess('Ok');
        }
      );
    } catch (err) {
      message.error({ key, content: t('uploadDocumentError', { error: err }) });
      onError(err);
    }
  };

  const handleOnChange = ({ file, fileList, event }) => {
    fileList = fileList.filter((file) => file.status !== 'done');
    setFileList([...fileList]);
  };

  return (
    <>
      <Button type="ghost" onClick={buttonClickHandler}>
        {t('updateImage')}
      </Button>
      <Modal title="" visible={visible} closable={false} footer={renderModalButtons()}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Upload.Dragger
            multiple
            accept="image/png, image/jpeg"
            customRequest={customRequest}
            onChange={handleOnChange}
            fileList={fileList}
            style={{ width: '100%' }}
            name={'file'}>
            <p className="ant-upload-drag-icon">
              <FileImageOutlined />
            </p>
            <p className="ant-upload-text">{t('selectFileTitle')}</p>
          </Upload.Dragger>
        </Space>
      </Modal>
    </>
  );
};
